import { RecommendedProductsTab } from './RecommendedProductsTab';

export default RecommendedProductsTab;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/RecommendedProductsTab/index.ts